// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__zwexG","tagButton":"styles_tagButton__e3Laq","icon":"styles_icon__COsKy","label":"styles_label__OQd37"};